export function invariant(condition, message, Err) {
  if (Err === void 0) {
    Err = Error;
  }

  if (!condition) {
    throw new Err(message);
  }
}